import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFiCategories, searchFip } from "../../services/api/fip.api";
import {
    FiCategory,
    SearchFipResponse,
} from "../../services/api/api.types";
import { MOCK_FIPS } from "../../services/api/mockData";
import { API_DEFAULTS } from "../../services/api/config";
import type { RootState } from "../../app/store";


const USE_MOCKS = process.env.REACT_APP_USE_MOCKS === "true";



export const fetchFiCategoriesThunk = createAsyncThunk<
    FiCategory[],
    void,
    { rejectValue: string; state: RootState }
>("fip/fetchCategories", async (_, { rejectWithValue, getState }) => {
    try {
        const state = getState();
        const { mobileNumber, sessionId } = state.auth;

        // Ensure we have session info. If not, maybe we shouldn't call this? 
        // Or assume it's called after auth.

        const res = await getFiCategories({
            I_MOBILENUMBER: mobileNumber,
            I_BROWSER: API_DEFAULTS.BROWSER,
            I_SESSION: sessionId || "",
            I_USERID: mobileNumber,
            UUID: state.auth.uuid || "",
        });
        // The CAMS response has the categories in the 'lst' property
        return res.lst || [];
    } catch {
        return rejectWithValue("Failed to load FI categories");
    }
});

export const searchFipThunk = createAsyncThunk<
    SearchFipResponse,
    { assetClassId: string }, // Updated to accept assetClassId
    { rejectValue: string; state: RootState }
>("fip/search", async (payload, { rejectWithValue, getState }) => {
    if (USE_MOCKS) return MOCK_FIPS as any;
    try {
        const state = getState();
        const { mobileNumber, sessionId } = state.auth;

        const res = await searchFip({
            UUID: state.auth.uuid || "",
            I_MOBILENUMBER: mobileNumber,
            I_USERID: mobileNumber,
            I_BROWSER: API_DEFAULTS.BROWSER,
            I_asset_class_id: payload.assetClassId,
            I_SESSION: sessionId || "",
            I_SEARCHKEY: "",
            I_SEARCHPAGENATION: "All",
        });

        if (res.RESULT_CODE !== "200") {
            return rejectWithValue(res.RESULT_MESSAGE || "FIP search failed");
        }
        return res;
    } catch {
        return rejectWithValue("FIP search failed");
    }
});

